<!-- dont autoload, if address already set -->
<!-- TODO make margins left and right same as formly fields below -->
<div class="phx-formly-padded mb-2">
    <label class="font-bold" *ngIf="this.model?.documentDefinition?.documentDirection === 'IN'">{{
        'document.vendor-postal-address' | translate
    }}</label>
    <label class="font-bold" *ngIf="this.model?.documentDefinition?.documentDirection === 'OUT'">{{
        'document.customer-postal-address' | translate
    }}</label>
    <label *ngIf="!this.model?.documentDefinition?.documentDirection">{{
        'document.postal-address' | translate
    }}</label>
    <app-document-delivery-postal-address-dropdown
        class="font-bold"
        [addressId]="model?.addressId"
        [autoloadItems]="false"
        [disabled]="model?.status === 'CO' || model?.status === 'RE'"
        [placeholder]="'postal-address.choose-postal-address' | translate"
        [value]="
            model?.deliveryPostalAddress?.id &&
            model?.originDeliveryPostalAddressId &&
            model?.originDeliveryPostalAddressId === model?.deliveryPostalAddressId
                ? { address: model?.deliveryAddress, postalAddress: model?.deliveryPostalAddress }
                : null
        "
        [direction]="model?.documentDefinition?.documentDirection"
        (valueChange)="selectedPostalAddressChanged($event)"
        [dataTestId]="'formly-document-delivery-postal-address-dropdown'"
    ></app-document-delivery-postal-address-dropdown>
</div>

<form
    *ngIf="subForm"
    [formGroup]="subForm"
    [disableForm]="{ state: model?.status === 'CO' || model?.status === 'RE', form: subForm }"
>
    <formly-form [model]="newModel" [fields]="fallbackFields" [form]="subForm" [options]="options">
    </formly-form>
</form>

<!-- nm: {{newModel | json}} -->
